






































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'

@Component
export default class FilterDeliverySacPublic extends Vue {
  @Prop({required: true}) value!: DeliverySacPublicRequest
}
